var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Service, { inject as service } from '@ember/service';
import { jsonGet } from '@square/dashboard-utilities/utils/xhr';
import { set } from '@ember/object';
import { getCookie } from '@square/dashboard-utilities/utils/cookies';
import { baseRpcUrl } from '@square/dashboard-utilities/utils/url';
import { assert } from '@ember/debug';
import { hash } from 'rsvp';
import environment from '@square/environment-utils/environment';
// eslint-disable-next-line no-restricted-imports

import { tracked } from '@glimmer/tracking';
function makeRequest(path) {
  return jsonGet(path, {
    headers: {
      'X-CSRF-Token': getCookie('_js_csrf')
    }
  });
}
// TBD
const WEEBLY_FEATURE_ID = 'so_buyer_subscriptions';

/*
Merchant states
  1. Itemization flag
  2. Itemized creation flag
  3. Is paid SO
  4. In rollout
  5. Future State: Can create subscriptions w/o sub creation flag?
    a. may just be a deprecation of current flags
*/
let ItemizationStatus = (_dec = service('subscriptions/ecom'), _class = class ItemizationStatus extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "features", _descriptor, this);
    _initializerDefineProperty(this, "ecomService", _descriptor2, this);
    _initializerDefineProperty(this, "catalogSentry", _descriptor3, this);
    _initializerDefineProperty(this, "userInfo", _descriptor4, this);
    _defineProperty(this, "isLoaded", false);
    _initializerDefineProperty(this, "_canUseItemization", _descriptor5, this);
    _defineProperty(this, "_isPaidSO", false);
    _initializerDefineProperty(this, "_inRollout", _descriptor6, this);
    _defineProperty(this, "_isSOMerchant", false);
  }
  async getEcomStatus() {
    try {
      const features = await this.ecomService.getCurrentFeatures();

      // if there's no error, the merchant has access to ecom services
      set(this, '_isSOMerchant', true);
      return features?.data[WEEBLY_FEATURE_ID]?.value;
    } catch (errors) {
      this.catalogSentry.withScope(scope => {
        scope.setExtra('errors', errors);
        this.catalogSentry.captureMessage('Error retrieving ecom features from weebly');
      });
      set(this, '_isSOMerchant', false);
      return false;
    }
  }
  async load() {
    if (!this.isLoaded) {
      const merchantToken = this.userInfo.merchantToken;
      try {
        const urlPath = baseRpcUrl(`/so-subscriptions-gate/${merchantToken}`);
        const {
          buyerSubsGateResponse,
          ecomFeature
        } = await hash({
          buyerSubsGateResponse: makeRequest(urlPath),
          ecomFeature: this.getEcomStatus()
        });
        set(this, '_isPaidSO', ecomFeature || false);
        set(this, '_inRollout', buyerSubsGateResponse.components.merchant_is_enabled_in_rollout);
        set(this, 'isLoaded', true);
      } catch (err) {
        this.catalogSentry.withScope(scope => {
          scope.setExtra('errors', err);
          this.catalogSentry.captureMessage(`Error loading itemization status for merchant ${merchantToken}`);
        });
        set(this, 'isLoaded', false);
        throw err;
      }
    }
  }

  // _canUseItemization indicates the seller is part of the itemization beta
  // _inRollout indicates the seller is part of the GA rollout
  get isItemized() {
    return this._inRollout || this._canUseItemization;
  }
  get isPaidSO() {
    // Only show errors when working locally to prevent new implementation from misbehaving
    if (environment().isDevelopment) {
      assert('Should call load() before using checking SO status', this.isLoaded);
    }
    return this._isPaidSO;
  }

  // We may have to refactor this depending on how we advance the rollout
  // e.g. non-SO sellers
  get showUpsellBanner() {
    return !this._isPaidSO && this.isItemized && this._inRollout && this._isSOMerchant;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "features", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "ecomService", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "catalogSentry", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "_canUseItemization", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.features.isEnabled('buyersubs/dashboard_subs_itemization');
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "_inRollout", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _class);
export { ItemizationStatus as default };